import React, { useState } from "react";
import agentImg from "../../asset/images/IBA/AgentImg.svg";
import AgentDetailsCardChild from "./AgentDetailsCardChild";

function AgentList({ type, header }) {
  console.log(header, "payoutheader");
  const [viewDetails, setViewDetails] = useState(true);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [data, setData] = useState([
    {
      agentName: "John Doe",
      sapCode: "12345",
      accOpened: "2024-06-29",
      status: "Active",
      details: "Details about John Doe",
    },
    {
      agentName: "Jane Smith",
      sapCode: "67890",
      accOpened: "2024-06-28",
      status: "Inactive",
      details: "Details about Jane Smith",
    },
    {
      agentName: "Alice Johnson",
      sapCode: "11223",
      accOpened: "2024-06-27",
      status: "Active",
      details: "Details about Alice Johnson",
    },
    {
      agentName: "Bob Brown",
      sapCode: "44556",
      accOpened: "2024-06-26",
      status: "Pending",
      details: "Details about Bob Brown",
    },
    {
      agentName: "John Doe",
      sapCode: "12345",
      accOpened: "2024-06-29",
      status: "Active",
      details: "Details about John Doe",
    },
    {
      agentName: "Jane Smith",
      sapCode: "67890",
      accOpened: "2024-06-28",
      status: "Inactive",
      details: "Details about Jane Smith",
    },
    {
      agentName: "Alice Johnson",
      sapCode: "11223",
      accOpened: "2024-06-27",
      status: "Active",
      details: "Details about Alice Johnson",
    },
    {
      agentName: "Bob Brown",
      sapCode: "44556",
      accOpened: "2024-06-26",
      status: "Pending",
      details: "Details about Bob Brown",
    },
  ]);

  const [filteredData, setFilteredData] = useState(data);
  const [searchTerm, setSearchTerm] = useState("");

  const handleDetailsClick = (agent) => {
    setSelectedAgent(agent);
    setViewDetails(false);
  };
  console.log(selectedAgent, "selectedAgent");
  const sortData = (key, ascending) => {
    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return ascending ? -1 : 1;
      if (a[key] > b[key]) return ascending ? 1 : -1;
      return 0;
    });
    setFilteredData(sortedData);
  };

  const sortDate = (ascending) => {
    const sortedData = [...filteredData].sort((a, b) => {
      const dateA = new Date(a.accOpened);
      const dateB = new Date(b.accOpened);
      return ascending ? dateA - dateB : dateB - dateA;
    });
    setFilteredData(sortedData);
  };

  const sortStatus = (ascending) => {
    const sortedData = [...filteredData].sort((a, b) => {
      if (a.status < b.status) return ascending ? -1 : 1;
      if (a.status > b.status) return ascending ? 1 : -1;
      return 0;
    });
    setFilteredData(sortedData);
  };

  const searchAgent = (term) => {
    setSearchTerm(term);
    const filtered = data.filter(
      (agent) =>
        agent.agentName.toLowerCase().includes(term.toLowerCase()) ||
        agent.sapCode.includes(term)
    );
    setFilteredData(filtered);
  };

  return (
    <>
      {viewDetails ? (
        <>
          <div className="card-title">
            <h2 className="h2-css-all">Agent Details</h2>
            <input
              type="text"
              className="agent-search"
              placeholder="Enter Agent Name or ID"
              value={searchTerm}
              onChange={(e) => searchAgent(e.target.value)}
            />
          </div>
          <div className="agent-table-wrapper scroll-table">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    <span className="invoice-th">
                      <span>{header.agentName}</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => sortData("agentName", true)}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => sortData("agentName", false)}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th scope="col" className="text-center">
                    {header.talktime}
                  </th>
                  <th scope="col" className="text-center">
                    <span className="invoice-th">
                      <span>{header.accountopened}</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => sortDate(true)}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => sortDate(false)}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th scope="col" className="text-center">
                    <span className="invoice-th">
                      <span>{header.totalPayout}</span>
                      <span>
                        <span
                          className="icon-up-triangle"
                          onClick={() => sortStatus(true)}
                        ></span>
                        <span
                          className="icon-down-triangle"
                          onClick={() => sortStatus(false)}
                        ></span>
                      </span>
                    </span>
                  </th>
                  <th scope="col" className="text-center">
                    {header.Details}
                  </th>
                  <th scope="col" className="text-center"></th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((agent, index) => (
                  <tr key={index}>
                    <td className="agent-name-cell">
                      <img src={agentImg} alt="agentImg" />
                      {agent.agentName}
                    </td>
                    <td className="text-center">{agent.sapCode}</td>
                    <td className="text-center">{agent.accOpened}</td>
                    <td className="text-center">
                      <select
                        className="iba-custom-select agent-select"
                        defaultValue={agent.status}
                      >
                        <option value="Active">Active</option>
                        <option value="Training">Training</option>
                        <option value="Onboarding">Onboarding</option>
                      </select>
                    </td>
                    <td className="text-center ">
                      <button
                        className="view-button"
                        onClick={() => handleDetailsClick(agent)}
                      >
                        View Details
                      </button>
                    </td>
                    <td className="text-center ">
                      <button className="performance-button">
                        Performance
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <AgentDetailsCardChild
          agent={selectedAgent}
          setViewDetails={setViewDetails}
        />
      )}
    </>
  );
}

export default AgentList;
